import { render, staticRenderFns } from "./ManualArticleAddDialog.vue?vue&type=template&id=56cdcdaa"
import script from "./ManualArticleAddDialog.vue?vue&type=script&lang=js"
export * from "./ManualArticleAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports